<script lang="ts" setup>
import type { CompositePrimaryKey } from '#layers/data-model/public';
import type { RelationMatchPickerProps } from './relation-match-picker';
import { computed } from 'vue';
import { useRelatedItemFilter } from '#layers/filters/composables/use-related-item-filter';

const { keys, oppositeCollection, disabled = false, readonly = false } = defineProps<RelationMatchPickerProps>();

const emit = defineEmits<{
	'update:keys': [keys: CompositePrimaryKey[]];
}>();

const { openRelatedItemDrawer } = useRelatedItemFilter();

const isEditable = computed(() => !disabled && !readonly);

async function open() {
	if (!isEditable.value) return;

	const result = await openRelatedItemDrawer(oppositeCollection.id, { selection: keys });

	if (result) emit('update:keys', result);
}
</script>

<template>
	<div
		class="flex h-full items-center px-1"
		:class="{ 'cursor-pointer': isEditable }"
		@click="open"
	>
		<slot />
	</div>
</template>
